export const MENU_BOOK_SEARCH = "menu-book-search";
export const RECIEVER_CHANNEL_TAB_CLICK = "reciever-channel-tab-click";
export const VOLUME_BUTTON_CLICK = "volume-button-click";

export const ADMIN_ACCOUNT_CREATED = "admin-account-created";
export const ADMIN_ACCOUNT_VERIFIED = "admin-account-verified";
export const BUSINESS_CREATED = "business-created";
export const BUSINESS_OUTLET_CREATED = "business-outlet-created";
export const LANDING_PAGE = "landing-page";
export const CHANNEL_ADDED = "channel-added";
export const CHANNEL_DIS_INTEGRATED = "channel-dis-integrated";
// export const BECAME_PAID_CUSTOMER = "become-paid-customer";
export const MENU_BOOK_VISITED = "menubook-visited";
export const MENU_MODIFIED = "menu-modified";
export const MENU_NEW_ITEM_ADDED = "menu-new-item-added";
export const MENU_ITEM_REMOVED = "menu-item-removed";
export const MENU_ITEM_AVAILABILITY_UPDATED = "menu-item-availability-updated";
export const MENU_PUBLISHED = "menu-published";
export const ORDER_DETAIL_PAGE_VISITED = "order-detail-page-visited";
export const ORDER_MODIFIED = "order-modified";
export const KOT_REPRINT = "kot-reprint";
export const ORDER_CANCELLED = "order-cancelled";
export const REPORT_PAGE_VISITED = "report-page-visited";
export const INVOICE_DETAILED_PAGE_VISITED = "invoice-detail-page-visited";
export const ITEM_WISE_SALES_DETAILED_PAGE_VISITED =
  "item-wise-sales-detail-page-visited";
export const APP_STORE_PAGE_VISITED = "apps-store-page-visited";
export const SETTINGS_PAGE_VISITED = "settings-page-visited";
export const ORDER_PAGE_VISITED = "order-page-visited";
export const ORDER_ACCEPTED = "order-accepted";
export const ORDER_AUTO_ACCEPTED = "order-auto-accepted";
export const ORDER_READY = "order-ready";
export const ORDER_PICKED_UP = "order-picked-up";
export const ORDER_DELIVERED = "order-delivered";
